import { useContext } from 'react';
import { Grid } from '@mui/material';
import { searchSchema, ticketCategoriesContext } from '../TicketCategoriesContext';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-mui';


let Filters = () => {
    let service = useContext(ticketCategoriesContext);

    return (
        <Formik
            enableReinitialize={true}
            validationSchema={searchSchema}
            initialValues={service.search}
            onSubmit={(values, action) => {
                service.doSearch(values);
                action.setSubmitting(false);
            }}
        >
            <Form>
                <Grid item xs={2}>
                    <Field
                        component={TextField}
                        label="Cerca"
                        name="searchText"
                        variant="standard"
                    />
                </Grid>
            </Form>
        </Formik>
    );
}

export default Filters;